import type { ComponentPortal } from "@angular/cdk/portal";
import type { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injector } from "@angular/core";


export abstract class PplPopoverPortalOutletFactory {

  abstract create(
    outletElement: Element,
    componentFactoryResolver: ComponentFactoryResolver,
    appRef: ApplicationRef,
    defaultInjector: Injector
  ): PplPopoverPortalOutlet;
}

export abstract class PplPopoverPortalOutlet {
  abstract attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T>;
  abstract detach(): void;
}
